export default () => ({
  entity: 'term',
  entities: 'terms',
  currentEntity: {},
  terms: [],
  errors: {
  }
})



// WEBPACK FOOTER //
// ./src/app/patient/terms/index/resources/data.js